
define('text!modules/reporting/campaigns/templates/chart_title_box.html',[],function () { return '<div class="chart-title-box">\n  <div class="chart-title" data-bind="chart_title">{{ chart_title }}</div>\n  <div class="chart-subtitle" data-bind="chart_subtitle">{{ chart_subtitle }}</div>\n</div>\n';});

